/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-28 14:29:37 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-28 10:31:29
 */
<template>
  <div class="registerd">
    <div class="content">
      <a-form
        class="search"
        :model="filter"
        :rules="rules"
      >
        <a-row :gutter="[30, 20]">
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="UserID"
            >
              <a-input
                v-model:value="filter.id"
                name="id"
                placeholder="Please enter"
                @keyup="handleIdInput"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Username"
            >
              <a-auto-complete
                v-model:value="filter.userName"
                :allow-clear="true"
                placeholder="Please enter"
                :options="userNameSuggestions"
                @select="onUserSelect"
                @keydown.enter.stop="changeUser"
                @clear="clearUser"
                @search="onUserSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Name"
            >
              <a-input
                v-model:value="filter.name"
                allow-clear
                placeholder="Please enter"
                @pressEnter="onSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Email"
            >
              <a-input
                v-model:value="filter.email"
                placeholder="Please enter"
                @pressEnter="onSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Region"
            >
              <a-select
                v-model:value="filter.audienceRegionId"
                allow-clear
                placeholder="Select"
                :options="audienceRegions"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Content Category"
            >
              <a-select
                v-model:value="filter.contentCategoryId"
                allow-clear
                placeholder="Select"
                :options="contentCategories"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Social Platform"
            >
              <a-select
                v-model:value="filter.socialPlatformId"
                allow-clear
                placeholder="Select"
                :options="socialPlatforms"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label-col="{ span: 8 }"
              label="Apply Time"
            >
              <a-range-picker
                v-model:value="filterDate"
                :allow-clear="true"
                :style="{ width: '100%' }"
                format="YYYY-MM-DD"
                :placeholder="['Start date', 'End date']"
                @change="setFilterDate"
              />
            </a-form-item>
          </a-col>
          <a-col
            :span="8"
            class="btns"
          >
            <a-button
              type="primary"
              @click="onSearch"
            >
              Search
            </a-button>
            <a-button @click="resetSearch">
              Reset
            </a-button>
            <a-button
              type="primary"
            >
              <a
                :href="`https://${apiDomain}/admin/influencer-marketing/v1/user/list/export?${exportUrlParams}`"
                download
              >Export</a>
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="content">
      <a-table
        class="registered-table"
        row-key="id"
        :data-source="data"
        :columns="columns"
        :scroll="{ x: 2520 }"
        :show-size-changer="false"
        :pagination="pagination"
        v-model:expanded-row-keys="expandedRowKeys"
        :expand-column-width="120"
        :row-expandable="(record) => getSubUserCount(record) > 0"
        size="small"
      >
        <template #expandColumnTitle>
          Sub-users
        </template>

        <template #expandIcon="{ expanded, record, expandable }">
          <button
            v-if="expandable"
            type="button"
            class="sub-users-expand-trigger"
            :aria-expanded="expanded"
            :aria-label="expanded ? 'Collapse sub-users' : 'Expand sub-users'"
            @click.stop="toggleSubUsersExpand(record, expanded)"
          >
            <span
              class="sub-users-expand-icon"
              :class="{ 'is-expanded': expanded }"
              aria-hidden="true"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 4.5L6 1.5L10 4.5"
                  stroke="currentColor"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 9.5L6 12.5L10 9.5"
                  stroke="currentColor"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="sub-users-count">({{ getSubUserCount(record) }})</span>
          </button>
          <span
            v-else
            class="sub-users-count sub-users-count--static"
          >-</span>
        </template>

        <template #expandedRowRender="{ record }">
          <div class="sub-users-breakdown">
            <h4 class="sub-users-breakdown__title">
              Breakdown by Sub-users
            </h4>
            <div class="sub-users-breakdown__panel">
              <a-spin :spinning="!!record.subUsersLoading">
                <a-table
                  class="sub-users-breakdown__table"
                  :columns="subUserColumns"
                  :data-source="record.subUsers || []"
                  :pagination="false"
                  size="small"
                  row-key="rowKey"
                  :show-header="true"
                  :bordered="false"
                  :scroll="{ y: SUB_USERS_TABLE_SCROLL_Y }"
                >
                  <template #bodyCell="{ column, record: sub }">
                    <template v-if="column.key === 'createTime'">
                      {{
                        sub.createTime
                          ? moment(sub.createTime).format('YYYY-MM-DD HH:mm:ss')
                          : '-'
                      }}
                    </template>
                    <template v-else-if="column.key === 'url'">
                      <a
                        v-if="sub.url"
                        
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{ sub.url }}</a>
                      <span v-else>-</span>
                    </template>
                    <template v-else>
                      {{ sub[column.dataIndex] || '-' }}
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </div>
          </div>
        </template>

        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'createTime'">
            {{ moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template
            v-else-if="
              column.key === 'name' ||
                column.key === 'email' ||
                column.key == 'operatorRemark' ||
                column.key == 'note'
            "
          >
            <div
              class="multiple3"
              :title="record[column.key]"
            >
              {{ record[column.key] }}
            </div>
          </template>
          <template v-else-if="column.key === 'registeredTime'">
            {{
              record.registeredTime
                ? moment(record.registeredTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
          <template v-else-if="column.key === 'phoneNum'">
            {{
              record.phoneNum
                ? `${
                  record.phoneNumPrefix ? '+' + record.phoneNumPrefix : ''
                } ${record.phoneNum}`
                : '-'
            }}
          </template>

          <template v-else-if="column.key === 'socialPlatforms'">
            <a-dropdown
              v-if="record.socialPlatforms?.length > 1"
              arrow
            >
              <span class="ant-dropdown-link multiple3">
                {{ record.socialPlatforms[0].platformName }}:
                {{ record.socialPlatforms[0].homepage }}
                <DownOutlined />
              </span>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-for="(platform, index) in record.socialPlatforms"
                    :key="index"
                    class="multiple3"
                    :title="platform.platformName + ': ' + platform.homepage"
                  >
                    {{ platform.platformName }}: {{ platform.homepage }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <span
              v-else-if="record.socialPlatforms?.length == 1"
              class="multiple3"
              :title="
                record.socialPlatforms[0].platformName +
                  ': ' +
                  record.socialPlatforms[0].homepage
              "
            >{{ record.socialPlatforms[0].platformName }}:
              {{ record.socialPlatforms[0].homepage }}</span>
          </template>
          <template v-else-if="column.key === 'primaryAudienceRegion'">
            {{ record.primaryAudienceRegion?.name || '-' }}
          </template>
          <template v-else-if="column.key === 'contentCategory'">
            {{ record.contentCategory?.name || '-' }}
          </template>
          <template v-else-if="column.key === 'actions'">
            <div class="actions">
              <a
                class="edit"
                :href="'/#/influencer/edit/' + record.id"
              >Edit</a>
              <a
                class="log"
                href="javascript:;"
                @click="emit('setShowLogModalId', record.id)"
              >Log</a>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment'
import { Table } from 'ant-design-vue'
import { apiDomain } from '../../../config'
import { ref, watch, reactive } from 'vue'
import { DownOutlined } from '@ant-design/icons-vue'
import { influencers, user } from '../../server/index'

const props = defineProps({
  data: { type: Array, default: () => [] },
})

const audienceRegions = ref([])
const socialPlatforms = ref([])
const contentCategories = ref([])
const phoneAreaCodeList = ref([])
const filterDate = ref([null, null])
const expandedRowKeys = ref([])
const initialFilters = {
  id: null,
  page: 1,
  size: 200,
  name: null,
  email: null,
  userName: null,
  audienceRegionId: null,
  socialPlatformId: null,
  contentCategoryId: null,
  reviewStatus: 'Registered',
  applyEndTime: filterDate.value[1] ? filterDate.value[1].endOf('date').valueOf() : null,
  applyBeginTime: filterDate.value[0] ? filterDate.value[0].startOf('date').valueOf() : null,
}
let search = reactive({ ...initialFilters })
let filter = reactive({ ...initialFilters })
const pagination = ref({
  current: 1,
  size: 'large',
  pageSize: 200,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    search.page = page
    getList()
  },
})
const exportUrlParams = ref(
  'reviewStatus=Registered' +
    (filterDate.value[1] ? '&applyEndTime=' + filterDate.value[1].endOf('date').valueOf() : '') +
    (filterDate.value[0] ? '&applyBeginTime=' + filterDate.value[0].startOf('date').valueOf() : '')
)
const emit = defineEmits(['getList', 'toggleStatus', 'setShowLogModalId'])
const subUserColumns = [
  { title: 'UserName', dataIndex: 'userName', key: 'userName', width: 140 },
  { title: 'Email', dataIndex: 'email', key: 'email', width: 200 },
  { title: 'Url', dataIndex: 'url', key: 'url', width: 240 },
  {
    title: 'ExternalUserKey',
    dataIndex: 'externalUserKey',
    key: 'externalUserKey',
    width: 200,
  },
  { title: 'Create Time', dataIndex: 'createTime', key: 'createTime', width: 178 },
]
const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', fixed: 'left', width: 60 },
  {
    title: 'Username',
    dataIndex: 'userName',
    key: 'userName',
    fixed: 'left',
    width: 120,
  },
  { title: 'Email', dataIndex: 'email', key: 'email', width: 240 },
  {
    title: 'Apply Time',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 178,
  },
  {
    title: 'Registered Time',
    dataIndex: 'registeredTime',
    key: 'registeredTime',
    width: 178,
  },
  {
    title: 'Register Source',
    dataIndex: 'registerSource',
    key: 'registerSource',
    width: 120,
  },
  { title: 'Name', dataIndex: 'name', key: 'name', width: 120 },
  /** 展开列与 Sub-users 表头合并 */
  Table.EXPAND_COLUMN,
  { title: 'Phone Number', dataIndex: 'phoneNum', key: 'phoneNum', width: 140 },
  {
    title: 'Primary Audience Region',
    dataIndex: 'primaryAudienceRegion',
    key: 'primaryAudienceRegion',
    width: 188,
  },
  {
    title: 'Social Platform',
    dataIndex: 'socialPlatforms',
    key: 'socialPlatforms',
    width: 300,
  },
  {
    title: 'Content Category',
    dataIndex: 'contentCategory',
    key: 'contentCategory',
    width: 188,
  },
  { title: "Influencer's Notes", dataIndex: 'note', key: 'note', width: 200 },
  {
    title: 'Operator Remark',
    dataIndex: 'operatorRemark',
    key: 'operatorRemark',
    width: 200,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    fixed: 'right',
    width: 100,
  },
]
const rules = {
  id: {
    type: 'Number',
    message: 'Please enter name.',
    trigger: 'change',
  },
}
// userName输入，返回suggestion列表，标识suggestion被选中一个，这时搜索就只需要传id，userName不传
let suggestionSelected = false

;[
  { action: 'getAudienceRegion', param: audienceRegions },
  { action: 'getSocialPlatformsList', param: socialPlatforms },
  { action: 'getContentCategoryList', param: contentCategories },
  {
    action: 'getPhoneAreaCodeList',
    param: phoneAreaCodeList,
    mapFun: (item) => {
      return {
        ...item,
        label: '+' + item['phoneCode'] + ' ' + item['englishName'],
        value: item.id,
      }
    },
  },
].forEach((item) => {
  influencers[item.action]().then((res) => {
    item.param.value = res.data.map((inner) => {
      return item.mapFun
        ? item.mapFun(inner)
        : {
            ...inner,
            label: inner.name,
            value: inner.id,
          }
    })
  })
})

/** size=small 单行约 39px，展开区默认最多展示 8 行，超出内滚 */
const SUB_USERS_VISIBLE_ROWS = 8
const SUB_USERS_BODY_ROW_HEIGHT = 39
const SUB_USERS_TABLE_SCROLL_Y = SUB_USERS_BODY_ROW_HEIGHT * SUB_USERS_VISIBLE_ROWS



function getSubUserCount(record) {

  const count = Number(
    record?.subUserCount ?? record?.subUsersCount ?? record?.subUsers?.length ?? 0
  )
  return Number.isFinite(count) ? count : 0
}



// function normalizeSubUsers(rows = []) {
//   return rows.map((item, index) => ({
//     ...item,
//     rowKey: item.id ?? item.externalUserKey ?? `${item.userName || 'sub'}-${index}`,
//     userName: item.userName ?? item.username ?? item.name ?? '',
//     email: item.email ?? '',
//     url: item.url ?? item.homepage ?? item.homePage ?? '',
//     externalUserKey: item.externalUserKey ?? item.externalKey ?? '',
//     createTime: item.createTime ?? item.createdTime ?? null,
//   }))
// }



function fetchSubUsers(record) {
  if (!record?.id || record.subUsersLoading) return
  if (Array.isArray(record.subUsers) && record.subUsersLoaded) return


}

/** 自定义展开图标时手动同步 expandedRowKeys，避免无法收起 */
function toggleSubUsersExpand(record, expanded) {
  const key = record?.id
  if (key == null || key === '') return
  if (expanded) {
    expandedRowKeys.value = expandedRowKeys.value.filter((k) => k !== key)
    return
  }
  if (!expandedRowKeys.value.includes(key)) {
    expandedRowKeys.value = [...expandedRowKeys.value, key]
  }
  fetchSubUsers(record)
}

function onSearch() {
  Object.assign(search, {
    ...filter,
    page: 1,
  })
  getList()
}

function resetSearch() {
  filterDate.value = [moment().subtract(180, 'days'), moment()]
  Object.assign(search, initialFilters)
  Object.assign(filter, initialFilters)
  getList()
}

const userNameSuggestions = ref([])
function onUserSearch(value) {
  value = value.trim()
  user
    .getSuggestionList('userName', {
      userName: value,
      size: 20,
    })
    .then((res) => {
      if (res.success) {
        userNameSuggestions.value = res.data.map((item) => {
          return { label: item.userName, value: item.id }
        })
      }
    })
}
function onUserSelect(id, option) {
  if (userNameSuggestions.value.length) {
    filter.id = id
    filter.userName = option.label
    suggestionSelected = true
  } else {
    filter.id = null
    suggestionSelected = false
  }
}

function getList() {
  const params = { ...search }

  if (params.id) {
    delete params.userName
  }

  expandedRowKeys.value = []

  emit('getList', params, (res) => {
    pagination.value.current = params.page

    if (params.page === 1) {
      pagination.value.total = res.total
    }
  })
}

function changeUser(e) {
  if (!suggestionSelected) {
    suggestionSelected = false
    filter.userName = e.target.value.trim()
  }
}

function clearUser() {
  filter.id = null
  filter.userName = null
  suggestionSelected = false
}

function setFilterDate(values) {
  if (!values || !values[0] || !values[1]) {
    filterDate.value = [null, null]
    filter.applyEndTime = null
    filter.applyBeginTime = null
    return
  }

  filter.applyEndTime = values[1].endOf('date').valueOf()
  filter.applyBeginTime = values[0].startOf('date').valueOf()
}

// 只能输入数字
function handleIdInput(e) {
  const value = e.target.value

  filter.id = value.replace(/\D/g, '')
  filter.userName = ''
}

getList()

watch(
  () => props.data,
  () => {
    expandedRowKeys.value = []
  }
)

watch(filter, (val) => {
  let params = ''
  const temp = { ...val }

  Object.keys(temp).forEach((key) => {
    if (temp['id']) {
      delete temp.userName
    }

    if (temp[key] && key != 'page' && key != 'size') {
      params = params + '&' + key + '=' + temp[key]
    }
  })

  exportUrlParams.value = params.substring(1)
})
</script>
<style lang="less" scoped>
@import '../../assets/less/common.less';
h2 {
  margin-bottom: 5px;
}
.multiple3 {
  max-height: 66px;
  .multiple-ellipsis(3);
}
.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > a {
    user-select: none;
    color: #1677ff;
    &:hover {
      color: #ff285a;
    }
    &:not(:last-of-type) {
      margin-right: 10px;
    }
  }
}
.ant-dropdown-link,
.platform-item {
  cursor: pointer;
}

.registered-table {
  /* 隐藏默认 +/-，Sub-users 列使用自定义双箭头 */
  :deep(.ant-table-row-expand-icon) {
    display: none !important;
  }

  :deep(.ant-table-row-expand-icon-cell),
  :deep(.ant-table-expand-icon-col) {
    padding-left: 12px !important;
    text-align: left;
  }

  :deep(.ant-table-expanded-row > .ant-table-cell) {
    padding: 0 !important;
    background: #fff;
  }
}

.sub-users-expand-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
  vertical-align: middle;

  &:hover .sub-users-expand-icon {
    opacity: 0.75;
  }
}

.sub-users-expand-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 14px;
  color: #4a90e2;
  line-height: 0;

  svg {
    display: block;
  }

  &.is-expanded {
    opacity: 0.85;
  }
}

.sub-users-count {
  color: #4a90e2;
  font-weight: 500;
  font-size: 13px;

  &--static {
    display: inline-block;
    color: #000;
  }
}

.sub-users-breakdown {
  padding: 16px 20px 20px;
  background: #fff;

  &__title {
    margin: 0 0 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    color: #333;
  }

  &__panel {
    overflow: hidden;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
  }

  &__table {
    :deep(.ant-table) {
      margin: 0 !important;
      background: #fff;
    }

    :deep(.ant-table-container) {
      border: none !important;
    }

    :deep(.ant-table-header) {
      border-bottom: 1px solid #f0f0f0;
    }

    :deep(.ant-table-body) {
      overflow-y: auto !important;
    }

    :deep(.ant-table-thead > tr > th) {
      background: #fafafa;
      font-weight: 600;
    }

    :deep(.ant-table-tbody > tr > td) {
      background: #fff;
    }

    a {
      color: #1677ff;
      word-break: break-all;
    }
  }
}
</style>